import './home-hero.scss';
import { register } from 'swiper/element/bundle';
import type { SwiperWebComponent } from '../../../assets/src/ts/types/swiper-element';

register();

// Slider du hero d'accueil : navigation et pagination custom via data-attributes.
const container = document.querySelector('.home-hero swiper-container') as SwiperWebComponent | null;

if (container && !container.dataset.homeHeroInit) {
    container.dataset.homeHeroInit = 'true';

    container.querySelectorAll('[data-swiper-prev]')?.forEach(btn =>
        btn.addEventListener('click', () => container.swiper.slidePrev())
    );
    container.querySelectorAll('[data-swiper-next]')?.forEach(btn =>
        btn.addEventListener('click', () => container.swiper.slideNext())
    );

    const paginationBtns = container.querySelectorAll<HTMLButtonElement>('[data-swiper-pagination-btn]');
    paginationBtns?.forEach((btn) => {
        btn.addEventListener('click', () => {
            const index = parseInt(btn.dataset.index || '0', 10);
            container.swiper.slideTo(index);
        });
    });
}
